<template>
  <div>
    <v-container class="page__wrapper">
      <!-- <v-row v-if="!groupSelect.is_free" class="mb-5">
        <v-col
          v-if="packageGroup.length !== 0"
          cols="12"
          xs="12"
          md="3"
          class="text-right"
        >
          <v-btn
            v-if="!groupSelect.is_free"
            class="mx-2 btn-custom"
            color="primary"
            active-class="primary white--text"
            depressed
            rounded
            height="42px"
            @click="goToPlan('packages', groupSelect.is_free ? groupId : '1')"
            ><v-icon class="mr-2">mdi-cart-plus</v-icon>
            <span style="font-size: 22px">{{ $t('Buy Package') }}</span>
          </v-btn>
        </v-col>
      </v-row> -->
      <v-row>
        <v-col cols="12" xs="12" md="6">
          <h2 class="primary--text">{{ $t('Rich menu') }}</h2>
        </v-col>
        <v-col cols="12" xs="12" md="6" class="d-flex justify-end align-center">
          <div
            class="text-right mr-2"
            v-if="
              dataLineRichmenu.length < qouta &&
              ((groupSelect.is_free && !isExpired) || !groupSelect.is_free)
            "
          >
            {{ $t('Remaining amount') }}
            {{ dataLineRichmenu.length }} /
            {{ qouta ? qouta : 0 }}
          </div>
          <v-btn color="primary" @click="UnLockPackage">
            {{ $t('upgrade_package') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="groupSelect && groupId">
        <v-col style="display: flex">
          <!-- <v-select
            value="1"
            style="max-width: 65px;"
            hide-details="true"
            :items="items"
            dense
            outlined
          ></v-select> -->
          <v-spacer></v-spacer>
          <!-- <v-btn class="btn-custom btn-icon mr-2" @click="shareDialog = true"
            ><v-icon>mdi-share-variant-outline</v-icon></v-btn
          >
          <v-btn class="btn-custom btn-icon"><v-icon>mdi-cog</v-icon></v-btn> -->
        </v-col>
      </v-row>

      <v-row>
        <template v-for="richMenu in filterRichmenu">
          <v-col :key="`richmenu${richMenu.id}`" cols="12" sm="6" md="4">
            <v-hover v-slot="{ hover }">
              <v-card
                outlined
                class="r0"
                min-width="100%"
                min-height=" 100%"
                :elevation="hover ? 2 : 12"
                :class="{ 'on-hover': hover }"
                style="
                  background-color: var(--v-background-base) !important;
                  border-radius: 25px 25px 0px 25px !important;
                  position: relative;
                  overflow: hidden;
                "
              >
                <div v-if="richMenu.is_free" class="card__ribbon">
                  {{ $t('Free Trial') }}
                </div>
                <v-card-title class="btn-action pa-3">
                  <v-chip
                    v-if="
                      richMenu.is_default_richmenu &&
                      richMenu.status &&
                      richMenu.ref_index
                    "
                    class="ma-2"
                    color="primary"
                  >
                    {{ $t('default') }}
                  </v-chip>
                  <!-- <v-btn
                    @click="analyticRichMenu(richMenu)"
                    class="mr-2"
                    elevation="0"
                    x-small
                    color="primary"
                    dark
                    fab
                  >
                    <v-icon>mdi-poll</v-icon>
                  </v-btn> -->

                  <v-menu transition="slide-y-transition" bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        class="mr-1"
                        elevation="0"
                        x-small
                        color="primary"
                        dark
                        fab
                        v-bind="attrs"
                        v-on="on"
                        :disabled="
                          !permissionRole.permission.shop_shop.rule_write
                        "
                      >
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-dialog
                        v-if="false"
                        v-model="dialogEditName[richMenu.id]"
                        persistent
                        max-width="800px"
                      >
                        <template #activator="{ on, attrs }">
                          <v-list-item
                            link
                            v-bind="attrs"
                            v-on="on"
                            @click="selectName(richMenu)"
                          >
                            <v-list-item-title>
                              <v-icon color="primary"
                                >mdi-square-edit-outline</v-icon
                              >
                              {{ $t('Edit name') }}</v-list-item-title
                            >
                          </v-list-item>
                        </template>
                        <v-card style="padding-bottom: 20px; opacity: unset">
                          <div
                            class="pointer"
                            style="
                              float: right;
                              margin-right: 30px;
                              margin-top: 10px;
                            "
                          >
                            <v-icon @click="closeDialogEditName(richMenu.id)"
                              >mdi-close</v-icon
                            >
                          </div>
                          <v-card-title
                            style="place-content: center; display: block"
                          >
                            <h3 class="mt-3">{{ $t('Edit name') }}</h3>
                            <validation-observer
                              ref="observer"
                              v-slot="{ invalid }"
                            >
                              <form @submit.prevent="EditNameSubmit(richMenu)">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Richmenu name"
                                  rules="required"
                                >
                                  <v-text-field
                                    v-model="richMenuName"
                                    outlined
                                    dense
                                    :error-messages="errors"
                                    required
                                  ></v-text-field>
                                </validation-provider>
                                <div class="text-right">
                                  <v-btn
                                    outlined
                                    width="50px"
                                    class="btn-back-richmenu w20 mr-5 br-7"
                                    @click="closeDialogEditName(richMenu.id)"
                                    >{{ $t('Back') }}</v-btn
                                  >
                                  <v-btn
                                    outlined
                                    class="btn-custom w20 btn-next-richmenu"
                                    type="submit"
                                    :disabled="invalid"
                                    >{{ $t('Submit') }}
                                  </v-btn>
                                </div>
                              </form>
                            </validation-observer>
                          </v-card-title></v-card
                        >
                      </v-dialog>
                      <v-list-item
                        v-if="richMenu.status && richMenu.ref_index"
                        link
                        @click="stopRichmenu(richMenu)"
                      >
                        <v-list-item-title>
                          <v-icon color="primary">mdi-cellphone-erase</v-icon>
                          {{ $t('Disconnect') }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-else
                        :disabled="richMenu.is_free"
                        link
                        @click="deleteRichmenu(richMenu)"
                      >
                        <v-list-item-title
                          style="color: var(--v-secondary-lighten3) !important"
                        >
                          <v-icon
                            style="
                              color: var(--v-secondary-lighten3) !important;
                            "
                            >mdi-delete</v-icon
                          >
                          {{ $t('Delete') }}</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-title>
                <v-img
                  v-if="richMenu.image_url"
                  :src="richMenu.image_url"
                  aspect-ratio="1.48"
                  contain
                  class="white--text align-end pointer"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  @click="getPermission('shop_shop') && editRichMenu(richMenu)"
                >
                  <template #placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                  <div
                    v-if="
                      richMenu.platform_channel_name &&
                      richMenu.status &&
                      richMenu.ref_index
                    "
                    outlined
                    class="ma-2"
                    style="
                      position: inherit;
                      width: fit-content;
                      border-radius: 5px;
                      color: rgb(255, 255, 255) !important;
                      background: var(--primary-color-lighten) !important;
                      padding: 3px;
                      float: right;
                    "
                  >
                    {{ richMenu.platform_channel_name }}
                  </div>
                </v-img>
                <div
                  v-else
                  class="start-btn pointer"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  @click="getPermission('shop_shop') && editRichMenu(richMenu)"
                >
                  <v-icon style="font-size: 70px" class="color-white"
                    >mdi-image-off</v-icon
                  >
                </div>
                <v-card-actions style="display: block">
                  <span class="mt-2">
                    <span
                      v-if="richMenu.status && richMenu.ref_index"
                      style="z-index: 2; position: relative; font-size: 22px"
                      ><v-icon color="#60BC45" style="font-size: 22px"
                        >mdi-checkbox-blank-circle
                      </v-icon>
                      <small style="color: #60bc45">
                        {{ $t('Active') }}
                      </small></span
                    >
                    <span
                      v-else
                      style="z-index: 2; position: relative; font-size: 22px"
                      ><v-icon color="red" style="font-size: 22px" small
                        >mdi-checkbox-blank-circle</v-icon
                      >
                      <small style="color: red">
                        {{ $t('Inactive') }}
                      </small>
                    </span>
                    <!-- <span class="color-primary middle" style="font-weight: 500">
                      {{ $t("Name") }} :</span
                    > -->
                    <br />
                    <div
                      v-show="!dialogEditName[richMenu.id]"
                      style="display: inline-flex; align-items: center"
                    >
                      <span class="middle ml-2">
                        {{ richMenu.name }}
                      </span>
                      <v-btn
                        style="box-shadow: none"
                        color="primary"
                        fab
                        x-small
                        dark
                        @click="editRichMenuName(richMenu)"
                        class="ml-2"
                        :disabled="!getPermission('shop_shop')"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                    <div
                      v-show="dialogEditName[richMenu.id]"
                      style="
                        margin-left: 10px;
                        margin-top: 10px;
                        display: inline-flex;
                        align-items: center;
                      "
                    >
                      <v-text-field
                        :ref="`edit_text_${richMenu.id}`"
                        :key="`edit_text_${richMenu.id}`"
                        v-model="richMenuName"
                        outlined
                        dense
                        required
                        small
                        hide-details
                        @keyup.enter="closeDialogEditName(richMenu.id)"
                      ></v-text-field>
                      <v-btn
                        style="box-shadow: none"
                        color="primary"
                        fab
                        x-small
                        dark
                        @click="EditNameSubmit(richMenu)"
                        class="ml-2"
                      >
                        <v-icon>mdi-content-save</v-icon>
                      </v-btn>
                      <v-btn
                        style="box-shadow: none"
                        color="primary"
                        fab
                        x-small
                        outlined
                        dark
                        @click="EditNameCancel(richMenu)"
                        class="ml-2"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </span>
                  <h5
                    v-if="groupSelect.is_free"
                    class="color-primary mt-3"
                    :class="
                      richMenu.set_default_schedule &&
                      richMenu.set_default_schedule.length > 0
                        ? ''
                        : 'text-center'
                    "
                  >
                    <vue-countdown
                      v-if="
                        GroupId &&
                        GroupId.expiredTime &&
                        GroupId.expiredTime > 0
                      "
                      v-slot="{ days, hours, minutes, seconds }"
                      :time="GroupId.expiredTime"
                      @end="onCountdownEnd"
                    >
                      {{
                        days !== 0
                          ? `${days} ${$t('days')}, ${hours} ${$t('hours')}`
                          : `${hours} ${$t('hours')}, ${minutes} ${$t(
                              'minutes'
                            )} ${seconds} ${$t('seconds')}`
                      }}
                    </vue-countdown>
                    {{ $t('free trial package') }}
                  </h5>
                  <div v-if="richMenu.set_default_schedule_setting">
                    <div
                      v-if="
                        richMenu.set_default_schedule_setting.start_date_at &&
                        richMenu.set_default_schedule_setting.start_time_at
                      "
                    >
                      <b style="color: #ff706b"
                        >{{ $t('activate_date_time') }} :</b
                      >
                      {{
                        `${formatDate(
                          richMenu.set_default_schedule_setting.start_date_at,
                          'DD/MM/YYYY'
                        )} - ${
                          richMenu.set_default_schedule_setting.start_time_at
                        }`
                      }}
                    </div>

                    <div
                      v-if="
                        richMenu.set_default_schedule_setting.end_date_at &&
                        richMenu.set_default_schedule_setting.end_time_at
                      "
                    >
                      <b style="color: #ff706b">{{ $t('ends_date_time') }} :</b>
                      {{
                        `${formatDate(
                          richMenu.set_default_schedule_setting.end_date_at,
                          'DD/MM/YYYY'
                        )} - ${
                          richMenu.set_default_schedule_setting.end_time_at
                        }`
                      }}
                    </div>
                    <div v-if="richMenu.set_default_schedule_setting.date">
                      <b style="color: #ff706b">{{ $t('working_day') }} :</b>
                      {{
                        richMenu.set_default_schedule_setting.date.toString()
                      }}
                    </div>
                  </div>
                </v-card-actions>
                <div
                  v-if="isExpired && richMenu.is_free"
                  class="expired_overlay"
                  style="
                    position: absolute;
                    background-color: #000000d1;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                  "
                >
                  <v-row
                    justify="center"
                    row
                    style="height: 100%; margin-top: 60px"
                  >
                    <v-col class="text-center">
                      <h2 class="white--text">{{ $t('Expired') }}</h2>

                      <v-btn outlined color="primary" @click="UnLockPackage"
                        ><h2>
                          <v-icon color="primary" class="color-white mb-1"
                            >mdi-lock</v-icon
                          >
                          {{ $t('Unlock to fix') }}
                        </h2></v-btn
                      >
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </template>

        <template
          v-if="
            dataLineRichmenu.length < qouta &&
            ((groupSelect.is_free && !isExpired) || !groupSelect.is_free)
          "
        >
          <v-col cols="12" sm="6" md="4">
            <v-hover v-slot="{ hover }">
              <v-card
                outlined
                min-width="100%"
                min-height=" 100%"
                class="pointer r0"
                :elevation="hover ? 2 : 12"
                :class="{ 'on-hover': hover }"
                style="
                  background-color: var(--v-background-base) !important;
                  border-radius: 25px 25px 0px 25px !important;
                  position: relative;
                  overflow: hidden;
                "
              >
                <div @click="getPermission('shop_shop') && createNew()">
                  <div v-if="groupSelect.is_free" class="card__ribbon">
                    {{ $t('Free Trial') }}
                  </div>
                  <div
                    class="start-btn"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  >
                    <v-icon style="font-size: 70px" class="color-white"
                      >mdi-plus</v-icon
                    ><span
                      v-if="groupSelect.is_free"
                      class="color-white"
                      style="
                        font-size: 40px;
                        vertical-align: middle;
                        font-weight: bold;
                      "
                      >{{ $t('Add') }}</span
                    >
                  </div>
                  <v-card-actions class="center">
                    <h1 v-if="!groupSelect.is_free" class="color-primary">
                      {{ $t('Add New') }}
                      {{ dataLineRichmenu.length }} /
                      {{ typeof qouta ? qouta : 0 }}
                    </h1>
                    <h4 v-else class="color-primary mt-3">
                      <vue-countdown
                        v-if="
                          GroupId &&
                          GroupId.expiredTime &&
                          GroupId.expiredTime > 0
                        "
                        v-slot="{ days, hours, minutes, seconds }"
                        :time="GroupId.expiredTime"
                        @end="onCountdownEnd"
                      >
                        {{
                          days !== 0
                            ? `${days} ${$t('days')}, ${hours} ${$t('hours')}`
                            : `${hours} ${$t('hours')}, ${minutes} ${$t(
                                'minutes'
                              )} ${seconds} ${$t('seconds')}`
                        }}
                      </vue-countdown>
                      {{ $t('free trial package') }}
                    </h4>
                  </v-card-actions>
                </div>
              </v-card>
            </v-hover>
          </v-col>
          <v-col
            v-if="filterRichmenu.length === 0 && groupSelect.is_free"
            cols="12"
            sm="6"
            md="4"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                outlined
                min-width="100%"
                min-height=" 100%"
                class="pointer r0"
                :elevation="hover ? 2 : 12"
                :class="{ 'on-hover': hover }"
                style="
                  border-radius: 25px 25px 0px 25px !important;
                  position: relative;
                  overflow: hidden;
                "
              >
                <div @click="getPermission('shop_shop') && createNew()">
                  <div v-if="groupSelect.is_free" class="card__ribbon">
                    {{ $t('Free Trial') }}
                  </div>
                  <div
                    class="start-btn"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  >
                    <v-icon style="font-size: 70px" class="color-white"
                      >mdi-plus</v-icon
                    ><span
                      v-if="groupSelect.is_free"
                      class="color-white"
                      style="
                        font-size: 40px;
                        vertical-align: middle;
                        font-weight: bold;
                      "
                      >{{ $t('Add') }}</span
                    >
                  </div>
                  <v-card-actions class="center">
                    <h4 class="color-primary mt-3">
                      <vue-countdown
                        v-if="
                          GroupId &&
                          GroupId.expiredTime &&
                          GroupId.expiredTime > 0
                        "
                        v-slot="{ days, hours, minutes, seconds }"
                        :time="GroupId.expiredTime"
                        @end="onCountdownEnd"
                      >
                        {{
                          days !== 0
                            ? `${days} ${$t('days')}, ${hours} ${$t('hours')}`
                            : `${hours} ${$t('hours')}, ${minutes} ${$t(
                                'minutes'
                              )} ${seconds} ${$t('seconds')}`
                        }}
                      </vue-countdown>
                      {{ $t('free trial package') }}
                    </h4>
                  </v-card-actions>
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
      <v-col v-if="groupSelect.is_free" cols="12" sm="12" md="8">
        <v-btn style="width: 100%" color="primary" @click="UnLockPackage"
          ><h2>
            <v-icon class="color-white mb-1">mdi-lock</v-icon>
            {{ $t('unlock') }}
          </h2></v-btn
        >
      </v-col>
      <div class="mt-7">
        <v-pagination
          v-model="page"
          :length="pages"
          color="primary"
          circle
          @input="updatePage"
        ></v-pagination>
      </div>

      <v-dialog
        v-model="dialogSalepage"
        class="banner-dialog"
        persistent
        max-width="500px"
        style="border-radius: 0px !important"
      >
        <v-card style="border-radius: 0px !important; opacity: 1 !important">
          <div style="position: absolute; right: 5px; top: 5px; z-index: 25">
            <v-btn color="primary" fab small flat @click="closeDialog">
              <v-icon style="font-size: 13px !important">close</v-icon>
            </v-btn>
          </div>
          <v-card-title style="display: flow-root; padding: 8px">
            <v-carousel hide-delimiters>
              <template v-for="(item, i) in bannerCarousels">
                <v-carousel-item
                  :key="i"
                  style="cursor: pointer"
                  :src="getImage(item.src)"
                  reverse-transition="fade-transition"
                  transition="fade-transition"
                  @click.stop="openDetailDialog(item.url)"
                ></v-carousel-item>
              </template>
            </v-carousel>

            <v-checkbox
              v-model="checkbox"
              style="float: left"
              color="primary"
              class="mt-3"
              :label="`ไม่ต้องแสดงหน้านี้อีก`"
            ></v-checkbox>
            <v-btn
              class="mt-2"
              style="float: right"
              outline
              color="primary"
              @click="closeDialog"
            >
              {{ $t('Close') }}
            </v-btn>
          </v-card-title>
        </v-card>
      </v-dialog>
    </v-container>

    <share-group v-if="shareDialog" v-model="shareDialog"></share-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShareGroup from '../components/lineRichmenuManager/ShareGroup'
import dayjs from 'dayjs'
// import CreditCard from "../components/account/CreditCard";
import VueCountdown from '@chenfengyuan/vue-countdown'
import moment from 'moment'
export default {
  components: {
    ShareGroup,
    // CreditCard,
    VueCountdown
  },
  data: () => ({
    toggleRemark: false,
    search: '',
    listCount: 0,
    historyList: [],
    page: 1,
    pageSize: 10,
    gbpReferenceNo: null,
    richMenuName: '',
    shareDialog: false,
    dialogEditName: [],
    dataLineRichmenu: [],
    loading: false,
    model: null,
    tabs: 1,
    groupSelect: { qouta: 0 },
    qouta: null,
    groupId: null,
    packageGroup: [],
    expiredDate: null,
    dialog: false,
    request: {},
    isDialogToPay: false,
    toggleBuy: false,
    count: 1,
    total: 69,
    isExpired: true,
    weekday: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ],
    checkbox: false,
    dialogSalepage: false,
    bannerCarousels: [
      {
        src: 'image/banner/ลูกค้าใหม่-05.png',
        url: 'https://m.me/361231620965547?ref=BannerZwizApp'
      }
    ]
  }),
  computed: {
    ...mapGetters({
      lineRichmenu: 'lineRichmenuManager/getLineRichMenu',
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      GroupId: 'lineRichmenuManager/getGroupId',
      clickTrial: 'lineRichmenuManager/getClickTrial',
      IdCreditCard: 'packagePlan/getIdCreditCard',
      permissionRole: 'ssoAccount/getPermissionRoleStore'
    }),
    pages() {
      let vm = this
      if (vm.pageSize == null || vm.listCount == null) return 0
      return Math.ceil(vm.listCount / vm.pageSize)
    },
    filterRichmenu() {
      if (this.search) {
        return this.dataLineRichmenu.filter((item) => {
          return item.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        //   this.historyList.sort(function(a, b) {
        //   return new Date(a.start_at) - new Date(b.start_at);
        // });
        const historyList = this._.cloneDeep(this.historyList)
        if (historyList.length > 0) {
          return historyList.map((item) => {
            if (
              item.set_default_schedule &&
              item.set_default_schedule.length > 0
            ) {
              item.set_default_schedule.sort(function (a, b) {
                return new Date(a.start_at) - new Date(b.start_at)
              })
            }
            if (
              item.set_default_schedule_setting &&
              typeof item.set_default_schedule_setting !== 'undefined'
            ) {
              if (
                item.set_default_schedule_setting.date &&
                item.set_default_schedule_setting.date !== 'undefined'
              ) {
                item.set_default_schedule_setting.date = JSON.parse(
                  item.set_default_schedule_setting
                )
              }
              item.set_default_schedule_setting = JSON.parse(
                item.set_default_schedule_setting
              )
            }
            return item
          })
        } else {
          return []
        }
      }
    }
  },
  async mounted() {
    const vm = this
    if (localStorage.getItem('dialogSalepage') == null) {
      vm.dialogSalepage = false
    } else {
      vm.dialogSalepage = JSON.parse(localStorage.getItem('dialogSalepage'))
    }
    this.$store.dispatch('setOverlay', true)
    try {
      await this.getLineRichmenuPackageByAccount()
      if (this.$route.query?.line_richmenu_package_id) {
        if (this.packageGroup && this.packageGroup.length > 0) {
          let group = this.packageGroup.find((el) => {
            return el.id == this.$route.query?.line_richmenu_package_id
          })

          if (group) {
            this.$store.dispatch('lineRichmenuManager/setSelectGroupId', group)
            if (this.$route.query?.rmid) {
              this.$router.push({
                path: `/${this.currentLang}/richmenu/maker`,
                query: {
                  rmid: this.$route.query?.rmid,
                  step: 8
                }
              })
            }
          }
        }
      }
      var res = await this.$store.dispatch(
        'lineRichmenuManager/getLineRichMenu'
      )
      if (res) {
        this.dataLineRichmenu = res.data.data
        // .map((richMenu) => {
        //   if (this.GroupId && richMenu.package_id === this.GroupId.id) {
        //     return richMenu;
        //   } else {
        //     return null;
        //   }
        // })
        // .filter((el) => {
        //   return el != null;
        // });
        if (this.packageGroup.length === 0) {
          this.selectTrial()
        }
        this.isExpired =
          this.GroupId && this.GroupId.expiredTime > 0 ? false : true
        this.$store.dispatch('setOverlay', false)

        this.initPage()
        this.updatePage(this.page)
      } else {
        this.$store.dispatch('setOverlay', false)
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `Something went wrong.`
        })
      }
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    getAllDay(date) {
      const vm = this
      let days = []
      let setDays = []

      date.map((item) => {
        if (!days.includes(vm.weekday[new Date(item.start_at).getDay()])) {
          days.push(vm.weekday[new Date(item.start_at).getDay()])
        }
      })
      vm.weekday.map((item) => {
        days.forEach((day) => {
          if (day === item) {
            setDays.push(vm.$t(day))
          }
        })
      })

      return setDays.toString()
    },
    formatDate(date, format) {
      return dayjs(date).format(format)
    },
    async editRichMenuName(richMenu) {
      const vm = this
      await vm.$nextTick()
      vm.$set(this.dialogEditName, richMenu.id, true)

      vm.richMenuName = richMenu.name
      await vm.$nextTick()
      vm.$refs[`edit_text_${richMenu.id}`][0].focus()
    },
    initPage() {
      let vm = this
      vm.listCount = vm.dataLineRichmenu.length
      if (vm.listCount < vm.pageSize) {
        vm.historyList = vm.dataLineRichmenu
      } else {
        vm.historyList = vm.dataLineRichmenu.slice(0, vm.pageSize)
      }
    },
    updatePage(pageIndex) {
      let vm = this
      let _start = (pageIndex - 1) * vm.pageSize
      let _end = pageIndex * vm.pageSize
      vm.historyList = vm.dataLineRichmenu.slice(_start, _end)
      vm.page = pageIndex
    },
    UnLockPackage() {
      const path = `/${this.currentLang}/home`
      if (this.$route.path !== path) this.$router.push(path)
    },
    onCountdownEnd() {
      this.isExpired = false
    },
    plus() {
      this.count = this.count + 1
      this.total = parseFloat(this.total) + 69
      this.setCreditCard()
      // parseFloat(
      //   (this.addNewDuringMonth(this.groupSelect.expired_timestamp) * 2.3 + 2.3).toFixed(2)
      // );
    },
    minus() {
      if (this.count > 1) {
        this.count = this.count - 1
        if (this.count !== 0) {
          this.total = parseFloat(this.total) - 69
          // parseFloat(
          //   (this.addNewDuringMonth(this.groupSelect.expired_timestamp) * 2.3 + 2.3).toFixed(2)
          // );
        }
        this.setCreditCard()
      }
    },
    selectName(richMenu) {
      this.richMenuName = richMenu.name
      this.$store.dispatch('lineRichmenuManager/setIdTemplate', richMenu.id)
    },
    async getLineRichmenuPackageByAccount() {
      var res = await this.$store.dispatch(
        'lineRichmenuManager/lineRichmenuPackageByAccount'
      )
      if (res) {
        this.$store.dispatch('setOverlay', false)
        var qouta = null
        this.packageGroup = res.data.data
          .map((el) => {
            let a = moment(el.expired_timestamp)
            let b = moment()
            qouta += el.qouta
            return {
              ...el,
              expiredTime: a.diff(b),
              expiredDay: a.diff(b, 'days')
            }
          })
          .sort(function (a, b) {
            return new Date(a.created_timestamp) - new Date(b.created_timestamp)
          })

        this.qouta = qouta
        if (this.GroupId === null) {
          this.$store.dispatch(
            'lineRichmenuManager/setSelectGroupId',
            this.packageGroup[0]
          )
        }
        await this.$nextTick()
        if (this.GroupId) {
          this.groupId = this.GroupId.id
          this.groupSelect = this.GroupId

          // 2.3 baht per day
          this.total = 69
          //  parseFloat(
          //   (this.addNewDuringMonth(this.groupSelect.expired_timestamp) * 2.3 + 2.3).toFixed(2)
          // );
        }

        // }
      } else {
        this.$store.dispatch('setOverlay', false)
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `Something went wrong.`
        })
      }
    },
    closeDialogEditName(richMenuID) {
      this.$set(this.dialogEditName, richMenuID, false)
    },
    selectGroup(item) {
      this.$store.dispatch('setOverlay', true)
      this.dataLineRichmenu = this.lineRichmenu
        .map((richMenu) => {
          if (richMenu.package_id === item.id) {
            return richMenu
          } else {
            return null
          }
        })
        .filter((el) => {
          return el != null
        })
      // if (typeof this.dataLineRichmenu.length !== "undefined") {
      this.$store.dispatch('setOverlay', false)
      // }
      // if (item.id === "trial") {
      //   this.groupId = item.groupId;
      //   this.dataLineRichmenu = this.lineRichmenu;
      // } else {
      this.groupId = item.id
      this.groupSelect = item
      // this.formatExpiredDate(this.groupSelect.expired_timestamp);
      this.$store.dispatch('lineRichmenuManager/setSelectGroupId', item)
      this.isExpired = this.GroupId.expiredTime > 0 ? false : true
      // this.dataLineRichmenu = item.richmenuData;
      // }
    },
    selectTrial() {
      this.$store.dispatch('setOverlay', true)
      this.dataLineRichmenu = this.lineRichmenu
        .map((richMenu) => {
          if (richMenu.package_id == null) {
            return richMenu
          } else {
            return null
          }
        })
        .filter((el) => {
          return el != null
        })
      this.$store.dispatch('setOverlay', false)
      this.groupSelect = { qouta: 0 }
      // this.dataLineRichmenu = this.lineRichmenu;
      this.groupId = null
    },

    addNewDuringMonth(expiredDate) {
      // const date1 = new Date();
      // const date2 = new Date(expiredDate);
      // const diffTime = Math.abs(date2 - date1);
      // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      // return diffDays;

      let a = moment()
      let b = moment(expiredDate)
      return a.diff(b, 'days')
    },

    async setCreditCard() {
      // this.$nextTick(async () => {
      this.request = {
        service: 'line_richmenu',
        // amount: parseFloat(this.total).toFixed(2),
        amount: 69,
        payment: {
          type: 'credit_card',
          credit_card_id: this.IdCreditCard
        },
        action: {
          type: 'addon',
          line_richmenu_package_id: this.groupId,
          addon: this.count
        }
      }
      // var res = await this.$store.dispatch("packagePlan/servicePaid", request);
      // console.log(res);
      // if (res && res.data.data.resultCode == "00") {
      //   this.gbpReferenceNo = res.data.data.gbpReferenceNo;
      //   this.$nextTick(() => {
      //     this.$refs.gbchargeform.submit();
      //   });
      //   this.$notify({
      //     group: "foo",
      //     type: "success",
      //     title: "Success",
      //     text: "Success",
      //   });
      // } else {
      //   this.$notify({
      //     group: "foo",
      //     type: "error",
      //     title: "Error",
      //     text: `something went wrong, please try again.`,
      //   });
      // }
      // });
    },

    editRichMenu(richMenu) {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Edit richmenu'
        // event_label: bot.pagename + utm,
      })
      if (this.groupId === null) {
        this.$store.dispatch('lineRichmenuManager/setCheckClickTrial', true)
      } else {
        this.$store.dispatch('lineRichmenuManager/setCheckClickTrial', false)
      }
      try {
        richMenu.content_json = JSON.parse(richMenu.content_json)
      } catch (error) {
        //
      }
      this.$store.dispatch('lineRichmenuManager/setTemplateSelect', richMenu)
      this.$store.dispatch('lineRichmenuManager/setTypeEditNew', 'edit')
      this.$store.dispatch('lineRichmenuManager/setIdTemplate', richMenu.id)
      if (this.$route.name !== `LineRichmenuManager`)
        this.$router.push({
          path: `/${this.currentLang}/richmenu/maker`,
          query: {
            rmid: richMenu.id
          }
        })
    },
    analyticRichMenu(richMenu) {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Analytic richmenu'
        // event_label: bot.pagename + utm,
      })
      try {
        richMenu.content_json = JSON.parse(richMenu.content_json)
      } catch (error) {
        //
      }
      this.$store.dispatch('lineRichmenuManager/setTemplateSelect', richMenu)
      this.$store.dispatch('lineRichmenuManager/setIdTemplate', richMenu.id)
      if (this.$route.name !== `LineRichmenuManager`)
        this.$router.push(
          `/${this.currentLang}/richmenu/analytic/${richMenu.id}`
        )
    },
    deleteRichmenu(richMenu) {
      this.$confirm(
        `${this.$t('you want to delete')} ${richMenu.name} ?`,
        this.$t('Are you sure?'),
        'question',
        {
          reverseButtons: true,
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }
      )
        .then(async () => {
          var res = await this.$store.dispatch(
            'lineRichmenuManager/deleteTemplate',
            richMenu.id
          )
          if (res) {
            var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
            this.$gtag.event('event', {
              event_category: prefix + 'Delete richmenu'
              // event_label: bot.pagename + utm,
            })
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Success',
              text: `${richMenu.name} has been deleted.`
            })

            this.historyList = this.historyList.filter(
              (e) => e.id !== richMenu.id
            )
            this.dataLineRichmenu.length = this.dataLineRichmenu.length - 1
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text:
                richMenu.status && richMenu.ref_index
                  ? `${richMenu.name} has not deleted. Because ${richMenu.name} has connected. `
                  : `${richMenu.name} has not deleted.`
            })
          }
        })
        .catch(() => {
          // console.log("OK not selected.");
        })
    },
    stopRichmenu(richMenu) {
      this.$confirm(
        `${this.$t('you want to disconnect')} ${richMenu.name} ?`,
        this.$t('Are you sure?'),
        'question',
        {
          reverseButtons: true,
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel')
        }
      )
        .then(async () => {
          var res = await this.$store.dispatch(
            'lineRichmenuManager/stopRichmenu',
            richMenu.id
          )
          if (res) {
            var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
            this.$gtag.event('event', {
              event_category: prefix + 'Disconnect richmenu'
              // event_label: bot.pagename + utm,
            })
            this.$store.dispatch('setOverlay', false)
            const path = `/${this.currentLang}/richmenu`
            if (this.$route.path !== path) {
              this.$router.push({ path })
            }
            richMenu.status = false
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Success',
              text: 'Your richmenu has been disconnected. '
            })
          } else {
            this.$store.dispatch('setOverlay', false)
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: `something went wrong, please try again.`
            })
          }
        })
        .catch(() => {
          // console.log("OK not selected.");
        })
    },
    createNew() {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Create richmenu'
        // event_label: bot.pagename + utm,
      })
      this.$store.dispatch('lineRichmenuManager/setTemplateSelect', {})
      this.$store.dispatch('lineRichmenuManager/setCheckClickTrial', false)
      if (this.$route.name !== `LineRichmenuManager`)
        this.$router.push(`/${this.currentLang}/richmenu/maker`)
      this.$store.dispatch('lineRichmenuManager/setTypeEditNew', 'create')
      this.$store.dispatch('lineRichmenuManager/setIdTemplate', null)
      // this.$store.dispatch("lineRichmenuManager/setSelectGroupId", { id: null });
    },
    createNewTrial() {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Create trial richmenu'
        // event_label: bot.pagename + utm,
      })
      this.$store.dispatch('lineRichmenuManager/setTemplateSelect', {})
      this.$store.dispatch('lineRichmenuManager/setCheckClickTrial', true)
      this.$store.dispatch('lineRichmenuManager/setSelectGroupId', {
        id: null
      })
      this.$store.dispatch('lineRichmenuManager/setIdTemplate', null)
      this.$store.dispatch('lineRichmenuManager/setTypeEditNew', 'create')
      if (this.$route.name !== `LineRichmenuManager`)
        this.$router.push(`/${this.currentLang}/richmenu/maker`)
    },
    async EditNameSubmit(richMenu) {
      this.$store.dispatch('lineRichmenuManager/setIdTemplate', richMenu.id)
      this.closeDialogEditName(richMenu.id)
      richMenu.name = this.richMenuName
      this.$store.dispatch('setOverlay', true)
      var res = await this.$store.dispatch(
        'lineRichmenuManager/putTemplateSelect',
        richMenu
      )
      if (res && !res._isError) {
        var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
        this.$gtag.event('event', {
          event_category: prefix + 'Edit name richmenu'
          // event_label: bot.pagename + utm,
        })
        this.$store.dispatch('setOverlay', false)
        this.$notify({
          group: 'foo',
          type: 'success',
          title: 'Success',
          text: `Richmenu name ${richMenu.name} has been changed`
        })
      } else {
        this.$store.dispatch('setOverlay', false)
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `something went wrong, please try again.`
        })
      }
    },
    EditNameCancel(richMenu) {
      this.closeDialogEditName(richMenu.id)
    },
    goToPlan(page, groupID) {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      if (page === 1) {
        this.$gtag.event('event', {
          event_category: prefix + 'Buy package'
          // event_label: bot.pagename + utm,
        })
      } else {
        this.$gtag.event('event', {
          event_category: prefix + 'View package'
          // event_label: bot.pagename + utm,
        })
      }

      if (this.$route.path !== `/packagesplan`)
        this.$router.push(`/packagesplan/${page || 'packages'}/${groupID}`)
    },
    setGtagCloseBanner() {
      const vm = this
      const prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      vm.$gtag.event('event', {
        event_category: `${prefix}close_banner`
      })
    },
    openDetailDialog(url) {
      window.open(url, '_blank')
    },
    closeDialog() {
      const vm = this
      localStorage.setItem('dialogSalepage', !vm.checkbox)
      vm.dialogSalepage = false
      if (vm.checkbox) {
        vm.setGtagCloseBanner()
      }
    },

    getPermission(permissionName) {
      if (!this.permissionRole) return false
      const isAllow = this.permissionRole.permission[permissionName].rule_write
      return isAllow
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card:not(.on-hover) {
  border: thin solid transparent;
}
.border-icon {
  border-radius: 15px 15px 0px 15px !important;
  background-image: linear-gradient(to right, #fd756f, #fe1467) !important;
}
.v-btn {
  span {
    font-size: 10px;
  }
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.middle {
  vertical-align: middle;
}

.v-card {
  transition: opacity 0.4s ease-in-out;
  padding: 5px;
}

.v-image {
  border-radius: 20px 20px 0px 20px !important;
}

.w20 {
  width: 20% !important;
}

.v-card:not(.on-hover) {
  opacity: 0.8;
}

.center {
  justify-content: center !important;
}
.start-btn {
  text-align: center;
  padding: 22%;
  background: var(--primary-color-lighten);
  border-radius: 20px 20px 0px 20px !important;
  width: 100%;
  height: auto;
}
.add-btn {
  text-align: center;
  padding: 22%;
  background: #ff706b;
  border-radius: 20px 20px 0px 20px !important;
  width: 100%;
  height: auto;
  h1 {
    font-weight: 300;
    color: #ffffff;
  }
  h2 {
    color: #ffffff;
  }
}
.fs-14 {
  font-size: 14px !important;
}
.btn-action {
  position: absolute;
  z-index: 3;
  right: 0px;
}
.btn-filter {
  background: none !important;
  width: 120px;
  float: right;
  border: 1px solid #ff706b !important;
  box-shadow: none;
}

.v-text-field {
  border-radius: 19px;
}
fieldset {
  border: 1px solid #ff706b !important;
}
.btn-remember {
  border: 2px solid white !important;
  color: #ffffff !important;
  padding: 17px !important;
  font-size: 18px !important;
  font-weight: 300;
}
.v-application .elevation-12 {
  box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.1),
    0px 12px 17px 2px rgba(0, 0, 0, 0.1), 0px 5px 22px 4px rgba(0, 0, 0, 0.1) !important;
}
.btn-icon {
  min-width: 40px !important;
  width: 40px;
  height: 40px;
  border-radius: 15px 15px 15px 0px !important;
}
</style>
